module.exports = __webpack_public_path__ + "public/img/unKnow.44609587.png";